import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  let {type} = theme.palette;
  let dark = type === "dark";
  return {
    container: {
      flex: "1 1 auto",
      textAlign: "left",
      width: 250
    },
    Content: {
      maxHeight: "300px",
      overflow: "auto",
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(0.5)
    },
    item: {

    },
    itemFlex: {
      display: "flex",
      flexFlow: "row",
      alignItems: "center"
    },
    message: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1)
    },
    date: {
      color: theme.palette.text.hint
    },
    divider: {
      marginBottom: theme.spacing(0.5),
      marginTop: theme.spacing(0.5)
    },
    errorIcon: {
      color: theme.palette.error[dark ? "light" : "dark"],
      marginRight: theme.spacing(0.5)
    }
  }
});
